"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabuUtilsConfig = exports.DefaultTabuUtilsConfig = void 0;
var entity_1 = require("./entity");
exports.DefaultTabuUtilsConfig = {
    resendAllowedProcedures: [
        entity_1.ProcedureIDs.OWNERSHIP_CHANGE,
        entity_1.ProcedureIDs.PROPERTY_CUT_OFF,
        entity_1.ProcedureIDs.DELAYED_PROPERTY_CUT_OFF,
        entity_1.ProcedureIDs.PROPERTY_ANNEX,
        entity_1.ProcedureIDs.DELAYED_PROPERTY_ANNEX,
    ],
};
exports.TabuUtilsConfig = {
    resendAllowedProcedures: [],
};
